module.exports = __webpack_public_path__ + "img/vi.ca0c9591.png";